import '../redeem-code-form';

export default (ctx, html) => html`
  <div class="modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content shadow">
        <div class="modal-header ">
          <button tabindex="0" focusfirst type="button" class="close" aria-label="Close" @click="${ctx.close}" data-bi-id="close_redeem_code_modal">
            <span class="ai ai-close-icon"></span>
          </button>
        </div>
        <redeem-code-form focuslast @submit="${ctx.codeSubmitted}" .submitting=${ctx.submitting} .errorCode="${ctx.errorCode}" class="mx-auto"></redeem-code-form>
      </div>
    </div>
  </div>
`;

